const TOKEN = `bluecar_${process.env.REACT_APP_ENV}_token`;
const FLOATING_BANNERS_STATE = `bluecar_${process.env.REACT_APP_ENV}_floating_banners_state`;

const getCookie = (key: string) => {
  const cookies = document.cookie.split(";");
  return cookies.reduce((current, cookie) => {
    const [cookieKey, value] = cookie.split("=");
    if (cookieKey?.trim() === key.trim() && value) return value;
    return current;
  }, "");
};

const setCookie = ({
  key,
  value,
  maxAgeSeconds,
}: {
  key: string;
  value: string;
  maxAgeSeconds?: number;
}) => {
  const maxAge = maxAgeSeconds ? `max-age=${maxAgeSeconds};` : "";
  document.cookie = `${key}=${value};${maxAge}path=/;`;
};

const removeCookie = (key: string) => {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

export const getToken = () => getCookie(TOKEN);
export const removeToken = () => removeCookie(TOKEN);
export const setToken = ({ token }: { token: string }) =>
  setCookie({ key: TOKEN, value: token });

export type FloatingBannersState = {
  ids: string[];
  dismissedAt: number;
};

export const getFloatingBannersState = () => {
  const state = getCookie(FLOATING_BANNERS_STATE);
  if (!state) return null;
  try {
    return JSON.parse(decodeURIComponent(state)) as FloatingBannersState;
  } catch (_) {
    removeCookie(FLOATING_BANNERS_STATE);
    return null;
  }
};

export const setFloatingBannersState = (state: FloatingBannersState) =>
  setCookie({
    key: FLOATING_BANNERS_STATE,
    value: encodeURIComponent(JSON.stringify(state)),
    maxAgeSeconds: 24 * 60 * 60,
  });

export const removeFloatingBannersState = () =>
  removeCookie(FLOATING_BANNERS_STATE);
